import { CatalogIcon, Content, DocsIcon, Header, Page } from '@backstage/core-components';
import Paper from '@mui/material/Paper';
import { CatalogSearchResultListItem } from '@backstage/plugin-catalog';
import {
  catalogApiRef,
  CATALOG_FILTER_EXISTS,
} from '@backstage/plugin-catalog-react';
import { TechDocsSearchResultListItem } from '@backstage/plugin-techdocs';
import { SearchType } from '@backstage/plugin-search';
import {
  SearchBar,
  SearchFilter,
  SearchResult,
  SearchPagination,
  useSearch,
} from '@backstage/plugin-search-react';
import { useApi } from '@backstage/core-plugin-api';

const SearchPage = () => {
  const { types } = useSearch();
  const catalogApi = useApi(catalogApiRef);

  return (
    <Page themeId="home">
      <Header title="Search" />
      <Content>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <Paper>
            <SearchBar />
          </Paper>
          <div style={{ display: 'grid', gridTemplateColumns: '250px 1fr', gap: 24 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <SearchType.Accordion
                name="Result Type"
                defaultValue="software-catalog"
                types={[
                  {
                    value: 'software-catalog',
                    name: 'Software Catalog',
                    icon: <CatalogIcon />,
                  },
                  {
                    value: 'techdocs',
                    name: 'Documentation',
                    icon: <DocsIcon />,
                  },
                ]}
              />
              <Paper style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {types.includes('techdocs') && (
                  <SearchFilter.Select
                    label="Entity"
                    name="name"
                    values={async () => {
                      const { items } = await catalogApi.getEntities({
                        fields: ['metadata.name'],
                        filter: {
                          'metadata.annotations.backstage.io/techdocs-ref':
                            CATALOG_FILTER_EXISTS,
                        },
                      });
                      const names = items.map(entity => entity.metadata.name);
                      names.sort();
                      return names;
                    }}
                  />
                )}
                <SearchFilter.Select
                  label="Kind"
                  name="kind"
                  values={['Component', 'Template']}
                />
                <SearchFilter.Checkbox
                  label="Lifecycle"
                  name="lifecycle"
                  values={['experimental', 'production']}
                />
              </Paper>
            </div>
            <div>
              <SearchPagination />
              <SearchResult>
                <CatalogSearchResultListItem icon={<CatalogIcon />} />
                <TechDocsSearchResultListItem icon={<DocsIcon />} />
              </SearchResult>
            </div>
          </div>
        </div>
      </Content>
    </Page>
  );
};

export const searchPage = <SearchPage />;
